import { useEffect, useRef } from "react";
import styles from './LandingPage.module.css'
import WebGLFluidEnhanced from 'webgl-fluid-enhanced';
import JumpingBar from "../../JumpingBar/JumpingBar";

const LandingPage = () => {

    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (containerRef.current) {
            const simulation = new WebGLFluidEnhanced(containerRef.current);  
            simulation.setConfig({
                backgroundColor: "#000000",
                colorPalette: [
                  "#021526",
                  "#6067AE",
                  "#CCCCFF"
                ],
                brightness: 0.1,
                bloomIntensity: 0.1,
                inverted: false,
              });
            simulation.start();  
            simulation.multipleSplats(10);
        }
    }, []);

    return (
        <div className={styles.landing_page} ref={containerRef}>
            <div className={styles.logo}></div>
            <JumpingBar />
        </div>
    )
};

export default LandingPage;
